import React from "react";
import { NumberInput } from "react-admin";

export const IntegerNumberInput = (props: any) => {
  return <NumberInput defaultValue={0} min={0} max={9999} step={1} parse={(v: string) => parseInt(v)} {...props} />;
};
